


















































































































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { storeResepFarmasi } from "@/store/modules/resepfarmasi";
import { userModule } from "@/store/modules/user";
import { appModule } from "@/store/modules/app";
import moment from "moment";

@Component
export default class CardListResep extends Vue {
  @Prop() listResep: Array<object>;
  @Prop() selectedItem;
  @Prop() clearDetail;

  @Prop() showTitle: boolean;
  resepText = "";
  activeResep = {};
  loading = false;
  allResep = [];
  showAll = false;
  showDetail = false;
  // selectedItem = null;
  selected = null;
  checkbox = [];
  isCheckAll = false;

  @Watch("listResep")
  changeList(v) {
    this.checkbox = [];
    this.isCheckAll = false;
  }

  checkAll() {
    // console.log(this.checkbox.length, " -- ", this.listResep.length);
    this.checkbox = [];
    if (this.isCheckAll) {
      // Check all
      for (const key in this.listResep) {
        this.checkbox.push(
          this.listResep[key]
          // this.listResep[key]["tgl"] + this.listResep[key]["no_transaksi"]
        );
        console.log(this.listResep[key]);
      }
    }
  }

  updateCheckall() {
    // console.log(this.checkbox.length, " -- ", this.listResep.length);
    if (this.checkbox.length == this.listResep.length) {
      this.isCheckAll = true;
    } else {
      this.isCheckAll = false;
    }
  }

  // get listResep() {
  //   return storeResepFarmasi.listResepFarmasi;
  // }
  get detailResep() {
    return storeResepFarmasi.detailResepFarmasi;
  }

  showResepTrn(resep) {
    this.showDetail = true;
    this.showAll = false;
    this.selected = resep;

    storeResepFarmasi.act_list_resepFarmasi_byTrn(resep);
  }

  showAllResep() {
    this.showAll = true;
    this.showDetail = false;

    this.allResep = this.listResep;
    this.selectedItem = null;
    this.selected = null;
  }

  getHumanDate(date) {
    return date ? moment(date, "YYYY-MM-DD").format("DD MMMM YYYY") : "";
  }
  @Watch("selectedItem")
  selectchange(v) {
    this.selectedItem = v;
  }
  @Watch("clearDetail")
  clearchange(v) {
    this.allResep = v;
    this.selected = null;
  }
  klik() {
    this.checkbox = [];
  }
}
